import React from "react";
import PropTypes from "prop-types";

import Menu from "./Menu";
import {
    Item,
    ItemHeading as Heading
} from "js/components/ProfileMenuMobile/styles";

import { PHOTO_ROYALTIES_FLAG } from "frontend/data/featureFlags";
import useFeatureFlag from "frontend/hooks/useFeatureFlag";

const CreatorProfileMenuMobile = ({
    creatorUsername,
    isPhotoCreator = false,
    isIconCreator = false
}) => {
    const hasRoyaltiesAccess = useFeatureFlag(PHOTO_ROYALTIES_FLAG);

    if (!isIconCreator && isPhotoCreator && !hasRoyaltiesAccess) return null;

    return (
        <>
            <Heading>Creator Tools</Heading>
            <Menu
                creatorUsername={creatorUsername}
                linkComponent={Item}
                isPhotoCreator={isPhotoCreator}
                isIconCreator={isIconCreator}
            />
        </>
    );
};

CreatorProfileMenuMobile.propTypes = {
    creatorUsername: PropTypes.string.isRequired
};

export default CreatorProfileMenuMobile;
